const Swal = require('sweetalert2');
import { IPartnerRestService } from "@modules/user/rest/partner/partner-rest-service";
import { IReCaptcha } from "@modules/common/tool/recaptcha/recaptcha";

RegistPartnerVerifyDirective.$inject = ["$uibModal", "eventBus", "partnerRestServiceV2", "qpMessageFadeindown", "$injector"];

export function RegistPartnerVerifyDirective(
    $uibModal: angular.ui.bootstrap.IModalService,
    eventBus: qpmn.common.tool.IEventBus,
    partnerRestServiceV2: IPartnerRestService,
    qpMessageFadeindown: qpui.IQpMessageFadeindown,
    $injector: angular.auto.IInjectorService
): ng.IDirective {
    return {
        restrict: "A",
        scope: {},
        controllerAs: "$ctrl",
        controller: ["$scope", function ($scope) {
            let ctrl = this;

            ctrl.$onInit = () => {
                eventBus.addEventListener('partnerVerifyModalBoxOpen', ctrl.partnerVrifyModalBox, this.$scope);
            }

            ctrl.partnerVrifyModalBox = (params) => {
                // 创建modal
                let partnerVrifyPrompt = $uibModal.open({
                    animation: false,
                    // 能否通过点击背景关闭
                    backdrop: false,
                    backdropClass: "",
                    // 模态框能否通过Esc关闭
                    keyboard: true,
                    controllerAs: '$ctrl',
                    controller: [function () {
                        let modalCtrl = this;

                        // 获取当前用户UserName
                        modalCtrl.userEmail = params.args.userEmail;

                        // 关闭邮箱提示框
                        modalCtrl.close = () => {
                            partnerVrifyPrompt.close();
                            eventBus.dispatch('partnerVerifyModalBoxClose');
                        }
                        // 重新发送partner验证邮件
                        modalCtrl.resendEmail = () => {

                            let recaptchaName: string;
                            if (window.isGrecaptcha) {
                                // 有谷歌验证码
                                recaptchaName = "gReCaptchaService";
                            } else {
                                // TODO: 降级策略
                                // 其他验证码方式，暂不支持
                                recaptchaName = "otherReCaptchaService";
                            }

                            // injector 不同captcha服务
                            ctrl.reCaptchaService = $injector.get(recaptchaName);
                            // 获取谷歌验证码
                            ctrl.reCaptchaService.getReCaptcha({ action: 'resendEmail' }).then((reCaptcha) => {
                                partnerRestServiceV2.anonymousResendMail(params.args.token, reCaptcha)
                                    .then(res => {
                                        if (res.success) {
                                            // 给出邮件发送成功提示
                                            qpMessageFadeindown.show('Email sent successfully');
                                            // 关闭当前模态框
                                            partnerVrifyPrompt.close();
                                            setTimeout(() => {
                                                eventBus.dispatch('partnerVerifyModalBoxClose')
                                            }, 1500);
                                        }
                                    }, (error) => {

                                        Swal.fire('Failed to send email, please click "Resend Verification Mail" again.');
                                    })
                            }, (failResp) => {
                                let title: qpLanguage.keys = "CONNECTION_RECAPTCHA_FAIL_TITLE";
                                let key: qpLanguage.keys = "A1102N001";
                                this.qpMessageDialog.warning({
                                    title: this.$translate.instant(title),
                                    content: this.$translate.instant(key),
                                    contentType: "HTML"
                                })
                            })
                        }
                    }],
                    windowClass: "verify-tip-modal-container",
                    template: require("./regist-partner-verify.modal.html").default,
                    size: "verify"
                });
            }
        }],
        link: () => { },
    }
}